<div class="total-table" *ngIf="form">
    <div class="form-container">
        <form [formGroup]="form">
            <table formArrayName="dataSource">
                <tbody>
                    <ng-container *ngFor="let element of dataSource.controls; let rowIndex = index">
                    <tr
                        [formGroup]="element"
                        [formGroupName]="rowIndex"
                    >
                        <td
                            style="width: fit-content"
                            class="bold-text"
                            [ngClass]="{
                                bottomBorder: rowIndex === indexForClosingRow || rowIndex === indexForCalculatedTotalRow
                            }"
                        >
                            <span *ngIf="element['controls']['totalIndex']" class="text">
                                {{ element['controls']['totalIndex']['value'] }}
                            </span>
                        </td>

                        <td class="bottomBorder" style="width: 33.5%">
                            <ng-container
                                *ngIf="rowIndex === indexForCalculatedTotalRow"
                            >
                                <input
                                    hamInput
                                    type="text"
                                    *ngIf="element['controls']['totalName']"
                                    [formControl]="element['controls']['totalName']"
                                    [placeholder]="'aumico_annual_report_proposal_enter_text' | i18next"
                                />
                            </ng-container>
                            <ng-container *ngIf="rowIndex === indexForOpeningRow || rowIndex === indexForClosingRow">
                                <span *ngIf="element['controls']['totalName']" class="text">
                                    {{ element['controls']['totalName']['value'] }}
                                </span>
                            </ng-container>
                        </td>
                        <td class="aumHighlight bottomBorder">
                            <ng-container
                                *ngIf="rowIndex === indexForCalculatedTotalRow"
                            >
                                <span *ngIf="element['controls']['currentTotal']" class="text">
                                    {{ element['controls']['currentTotal']['value'] | finNumber : numberFormat }}
                                </span>
                            </ng-container>

                            <input
                                *ngIf="rowIndex === indexForOpeningRow || rowIndex === indexForClosingRow"
                                hamInput
                                type="number"
                                class="number-input"
                                [formControl]="element['controls']['currentTotal']"
                                [placeholder]="'aumico_annual_report_proposal_enter_text' | i18next"
                            />
                        </td>

                        <!-- Previous Total Column -->
                        <td [ngClass]="{ bottomBorder: true }">
                            <ng-container
                                *ngIf="rowIndex === indexForCalculatedTotalRow"
                            >
                                <span *ngIf="element['controls']['previousTotal']" class="text">
                                    {{ element['controls']['previousTotal']['value'] | finNumber : numberFormat }}
                                </span>
                            </ng-container>
                            <ng-container *ngIf="rowIndex === indexForOpeningRow || rowIndex === indexForClosingRow">
                                <input
                                    hamInput
                                    type="number"
                                    [formControl]="element['controls']['previousTotal']"
                                    [placeholder]="'aumico_annual_report_proposal_enter_text' | i18next"
                                />
                            </ng-container>
                        </td>
                    </tr>
                    </ng-container>
                </tbody>
            </table>
        </form>
    </div>
</div>
